export default {
  // 判断是移动端还是PC端
  isDeviceType() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  }
};



// WEBPACK FOOTER //
// ./src/utils/isMobile.js